import { AnyDashboardWidget, DashboardWidget } from './types'
import { CountdownWidget } from './Countdown'
import { KpiRowProgressListWidget } from './KpiRowProgressList'
import { KpiRingGridWidget } from './KpiRingGrid'
import { KpiSpotlightWidget } from './KpiSpotlight'
import { KpiYtdTableWidget } from './KpiYtdTable'
import { KpiBarChartWidget, KpiBarChartQuarterWidget } from './KpiBarChart'
import { KpiTileWidget } from './KpiTile'
import { LadderWidget } from './Ladder'
import { MatchDetailsWidget } from './MatchDetails'
import { MatchesWidget } from './Matches'
import { TargetProgressWidget } from './TargetProgress'
import { Top5KpiWidget } from './Top5Kpi'

// DashboardWidget is invariant in its settings type S, so a union of widgets
// with different S can't be expressed without `any` here. The cast below
// narrows to AnyDashboardWidget for downstream use.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const allWidgets: DashboardWidget<any>[] = [
  KpiRowProgressListWidget,
  KpiRingGridWidget,
  KpiYtdTableWidget,
  KpiBarChartWidget,
  KpiBarChartQuarterWidget,
  KpiTileWidget,
  KpiSpotlightWidget,
  CountdownWidget,
  TargetProgressWidget,
  MatchesWidget,
  MatchDetailsWidget,
  LadderWidget,
  Top5KpiWidget,
]

export const WIDGETS: AnyDashboardWidget[] =
  allWidgets as unknown as AnyDashboardWidget[]

const byType: Map<string, AnyDashboardWidget> = new Map(
  WIDGETS.map((w) => [w.type, w])
)

export function getDashboardWidget(
  type: string
): AnyDashboardWidget | undefined {
  return byType.get(type)
}

export function hasDashboardWidget(type: string): boolean {
  return byType.has(type)
}
